import { Flex, Group, Pill, Stack, Text } from '@mantine/core';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { CommitteeProofAction } from './Proof';
import { CommitteeDeleteButton } from './components/CommitteeDeleteButton';
import { Committee } from './model/CommitteeTypes';

interface CommitteeViewProps {
  committee: Committee;
}

export function CommitteeView(props: CommitteeViewProps) {
  const { committee } = props;
  const { title, startYear, endYear, type, authors } = committee;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{`${title} (${startYear} - ${endYear ?? '?'})`}</Text>

            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <CommitteeDeleteButton committeeId={committee.id} />
            </Group>
          </Flex>

          <Group>
            <Pill>Tip: {type?.name}</Pill>
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <CommitteeProofAction
        committeeId={committee.id}
        authors={authors}
      />
    </Stack>
  );
}
